import { NgStyle } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';

import {
    CasinoCoreGamelaunchService,
    CasinoManager,
    CasinoStylesService,
    ConfigProviderService,
    GameLaunch,
    GameManagerService,
} from '@casinocore/platform/core';
import { TrackingService } from '@frontend/vanilla/core';

@Component({
    selector: 'cc-news-feed-v2-newgames',
    templateUrl: 'news-feed-v2-newgames.component.html',
    imports: [NgStyle],
})
export class NewsFeedV2NewgamesComponent implements OnInit {
    @Input() gameData: any;
    @Input() newsFeedItem: any;
    @Input() index: number;
    @Input() lobbyType: string;
    @Input() attributes: any;
    @Input() data: any;
    gameName: string = '';
    gameIcon: any;
    isTouch: boolean;
    categoryType: string;

    private readonly tracking = inject(TrackingService);
    private readonly casinoManager = inject(CasinoManager);
    private readonly configProviderService = inject(ConfigProviderService);
    private readonly gameLaunchService = inject(CasinoCoreGamelaunchService);
    private readonly casinoStyles = inject(CasinoStylesService);
    private readonly gameManagerService = inject(GameManagerService);

    ngOnInit() {
        this.isTouch = this.casinoManager.isTouch();
        this.categoryType = 'NewsFeed';
        this.gameName = this.gameData.name;
        this.gameIcon = this.gameData.icon.src;
        const feature: any = this.configProviderService.provideFeaturesConfig();
        if (feature.enableGameIconTheming) this.gameIcon = this.casinoStyles.appendTheme(this.gameIcon, this.gameData.name);
    }

    itemCliked() {
        const gameInfo: any = this.gameManagerService.getGameInfo(this.newsFeedItem.gameID);
        this.newsFeedItem.gameId = this.newsFeedItem.gameID;
        if (gameInfo) {
            this.itemTrackingOnClick(gameInfo.game, this.index, gameInfo.name);
        }
        const gameModel = new GameLaunch();
        gameModel.game = this.newsFeedItem;
        gameModel.isTouch = this.isTouch;
        gameModel.gamePosition = this.index;
        gameModel.categoryType = this.categoryType;
        gameModel.from = 'q';
        gameModel.replaceRouteInHistory = false;
        gameModel.isDemoLaunch = false;
        gameModel.skipUnfinGame = false;
        gameModel.gameLaunchedFrom = this.categoryType;
        gameModel.gridPosition = 1;
        gameModel.gameSection = this.categoryType;
        gameModel.gameContainer = '';
        gameModel.game.lobbyType = this.lobbyType;
        gameModel.returnUrl = window.location.href;
        gameModel.clickTimeStamp = this.gameLaunchService.currentTimeStamp();
        this.gameLaunchService.launchGame(gameModel);
    }
    itemTrackingOnClick(gameId: string, positionEvent: number, gameName: string) {
        this.tracking.triggerEvent('Event.Clicks', {
            'component.CategoryEvent': 'NewsFeed',
            'component.LabelEvent': 'Game_Launch',
            'component.ActionEvent': 'Click',
            'component.PositionEvent': ++positionEvent,
            'component.LocationEvent': this.data ? this.data.trackPos : '',
            'component.EventDetails': gameId,
            'component.URLClicked': 'not applicable',
            'component.DisplayGameName': gameName,
        });
    }
}
